<template>
    <div class="parentClassList content">
        <div class="step_btn">
            <Button type="primary" v-if="$route.query.courseStatus == 2" @click="addParentClass()">添加</Button>
            <!--<Button type="warning" @click="addSort()" style="float: right">排序</Button>-->
        </div>
        <div class="step_tab">
            <Table :loading="loading" border ref="selection" :columns="columns" :data="parentClassList"></Table>
        </div>
    </div>
</template>
<style>
.parentClassList>div {
    padding: 10px 0;
}
</style>
<script>
import http from "../../../libs/http.js"
//    import filters from "../../../libs/filters.js"
export default {
    data() {
        return {
            loading: false,
            sectionId: this.$route.query.sectionId,
            courseId: this.$route.query.courseId,
            courseTitle: this.$route.query.courseTitle,
            sectionName: this.$route.query.sectionName,
            parentClassList: [],
            partList: [],
            columns: [{
                    title: 'NO.',
                    key: 'seq'
                },
                {
                    title: 'part类型',
                    key: 'partType',
                    render: (h, params) => {
                        return h("span", this.changePartType(params.row.partType));
                    }
                },


                {
                    title: '操作',
                    width: 300,
                    key: 'action',
                    render: (h, params) => {
                        return h('div', [

                            h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                },
                                style: {
                                    marginRight: '10px'
                                },
                                on: {
                                    click: () => {
                                        this.addParentClass(params.row.id)
                                    }
                                }
                            }, '编辑'),

                            h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small',
                                    disabled: this.$route.query.courseStatus == 1 ? true : false,
                                },
                                style: {
                                    marginRight: '10px'
                                },
                                on: {
                                    click: () => {
                                        this.deleteParentClass(params.row.id)
                                    }
                                }
                            }, '删除'),
                            h('ButtonGroup', {
                                style: {
                                    marginLeft: '20px'
                                }
                            }, [
                                h('Button', {
                                    props: {
                                        type: 'info',
                                        size: 'small',
                                        disabled: this.$route.query.courseStatus == 1 ? true : false,
                                        icon: 'ios-arrow-up',
                                        ghost: true
                                    },
                                    on: {
                                        click: () => {
                                            this.move(params.row, 0)
                                        }
                                    }
                                }),
                                h('Button', {
                                    props: {
                                        type: 'info',
                                        size: 'small',
                                        disabled: this.$route.query.courseStatus == 1 ? true : false,
                                        icon: 'ios-arrow-down',
                                        ghost: true
                                    },
                                    on: {
                                        click: () => {
                                            this.move(params.row, 1)
                                        }
                                    }
                                }),
                            ]),
                        ]);
                    }
                }
            ]
        }
    },
    created() {
        this.getParentClass()
    },

    methods: {
        // 获取parentClass表格
        getParentClass() {
            let that = this;
            http.post('/custom/parentCourse/list', {
                courseId: that.courseId,
                sectionId: that.sectionId
            }).then(res => {
                that.parentClassList = res
                this.getPart()
            })
        },
        //获取part列表
        getPart() {
            let that = this;
            that.loading = true;
            http.post('/custom/partInfo/list', {
                status: 0,
            }).then(res => {
                if (res) {
                    that.partList = res
                    that.loading = false;
                }

            })
        },
        changePartType(type) {
            for (var i = 0; i < this.partList.length; i++) {
                if (type == this.partList[i].id) {
                    return this.partList[i].name;
                }
            }
        },
        //            //排序
        //            addSort() {
        //                let that = this;
        //                that.landing = true;
        //                http.post('/custom/parentCourse/sort', {
        //                    courseId: that.courseId,
        //                    sectionId: that.sectionId
        //                }).then(res => {
        //                    that.getParentClass()
        //                    that.landing = false;
        //                })
        //            },
        //添加和编辑parentClass
        addParentClass(parentClassId) {
            let _query = {
                courseStatus: this.$route.query.courseStatus,
                courseId: this.$route.query.courseId,
                sectionId: this.$route.query.sectionId,
                courseTitle: this.$route.query.courseTitle,
                sectionName: this.$route.query.sectionName,
                parentClassId: parentClassId
            }
            if (parentClassId) {
                this.$router.push({ path: 'editParentClass', query: _query })
            } else {
                this.$router.push({ path: 'addParentClass', query: _query })
            }
        },
        //上移,下移
        move(row, type) {
            // type 0上移 1下移
            this.loading = true;
            http.post('/custom/parentCourse/move', {
                seq: row.seq,
                id: row.id,
                sectionId: this.sectionId,
                courseId: this.courseId,
                up: type
            }).then(res => {
                this.loading = false;
                if (res) {
                    this.getParentClass()
                }
            })
        },
        //删除parentClass
        deleteParentClass(id) {
            let that = this
            this.$Modal.confirm({
                title: '提示',
                content: '确定删除该家长指南?',
                onOk: () => {
                    http.post('/custom/parentCourse/del', {
                        id: id,
                        sectionId: that.sectionId,
                        courseId: that.courseId,
                    }).then(res => {
                        if (res) {
                            that.getParentClass()
                            that.$Message.success('删除成功');
                        }
                        
                    })
                }
            });
        }
    },

}
</script>